import { Box } from '@rsos/components/capstone/base';
import VideoPlayer from '@rsos/video';

export const NO_PLAYBACK_RATE = 'noplaybackrate';

const CustomVideoRenderer = props => {
  const { schema, path, ownData } = props;

  const renderMedia = () => {
    return (
      <div className={`depth-${path.length}`}>
        <strong className="default-type-string default-type-string-title">
          {schema.title}
        </strong>
        <Box mx={3}>
          <VideoPlayer
            playerId={`video-${ownData}`}
            src={ownData}
            controls
            controlsList={NO_PLAYBACK_RATE}
            disablePictureInPicture
          />
        </Box>
      </div>
    );
  };

  return <div className="CustomVideoRenderer">{renderMedia()}</div>;
};

export default CustomVideoRenderer;
